import { wrapSvg } from '../../util/SvgImage';

export const ChevronRight = wrapSvg(
  <svg height={32} width={32} viewBox="0 0 24 24" fill="currentColor">
    <path d="M9.29289 8.68396C8.90237 8.29449 8.90237 7.66302 9.29289 7.27355C9.68342 6.88408 10.3166 6.88408 10.7071 7.27355L14.7071 11.2628C15.0976 11.6523 15.0976 12.2837 14.7071 12.6732L10.7071 16.6624C10.3166 17.0519 9.68342 17.0519 9.29289 16.6624C8.90237 16.273 8.90237 15.6415 9.29289 15.252L12.5858 11.968L9.29289 8.68396Z" />
  </svg>,
);
